module.exports = __webpack_public_path__ + "static/assets/3d01caa7b3aaa53cfd249a1a7a22f7fb.png";